import { Component, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MapDistributionService } from 'src/app/services/map-distribution.service';

@Component({
	selector: 'app-map-distribution-popup',
	template: `
		<div class="product-detail-popup popup__content">
			<div class="product-detail__wrapper" dir="rtl">
				<h3 style="text-align: center">אנא בחר יום להציג</h3>

				<div class="flex flex-column gap" dir="rtl">
					<mat-form-field color="primary" dir="rtl">
						<mat-label>תאריך</mat-label>
						<input readonly="true" [formControl]="_mapDistribution.showDateControl" matInput [matDatepicker]="picker" (click)="picker.open()" />
						<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
						<mat-datepicker #picker></mat-datepicker>
					</mat-form-field>
				</div>

				<button mat-raised-button color="primary" matDialogClose>בחר</button>
			</div>
		</div>
	`,
	styleUrls: ['./map-distribution-popup.component.scss'],
})
export class MapDistributionPopupComponent {
	_mapDistribution = inject(MapDistributionService);

	private fb = inject(FormBuilder);
	constructor() {}

	form = this.fb.group({
		date: [new Date(), Validators.required],
	});

	handleError() {
		alert('ישנה תקלת תקשורת, אנא נסה שנית מאוחר יותר');
		history.back();
		return;
	}
}
